module.exports = __webpack_public_path__ + "img/B554.73123011.jpg";